module.exports = __webpack_public_path__ + "static/media/EnvPromo-Shot104.4b976510.jpg";